import React, { useState } from "react";
import { useListing } from "@/providers";

export const AirportInfo = () => {
    const { listingDetails } = useListing();

    const {
        airports,
    } = listingDetails;

    const [showAll, setShowAll] = useState(false);

    // Show the first airport initially
    const initialAirports = showAll ? airports : [airports[0]];

    const parseStringToArray = (value) => {
        if (Array.isArray(value)) return value; // If it's already an array, return as is
        if (typeof value === 'string') {
            return value.replace(/["\[\]\\]/g, '').split(',');
        }
        return []; // Return an empty array if value is neither string nor array
    };



    return (
        <div>
            {initialAirports.map((airport, index) => (
                <div key={index} className="airport-section">
                    <div className="airport-info">

                        <a href={airport?.air_nav} target="_blank" rel="noopener noreferrer">
                            <h3 className="pb-2 mb-4 text-lg font-semibold text-gray-800 uppercase border-b">
                                {airport?.airport_name} Information ( Airport )
                            </h3>
                        </a>
                        <ul className="space-y-3">
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-plane"></i>
                                    <span className="font-semibold text-gray-600">Airport Use:</span>
                                </div>
                                <span className="text-gray-800">{airport.airport_use || "---"}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-compass"></i>
                                    <span className="font-semibold text-gray-600">Orientation:</span>
                                </div>
                                <span className="text-gray-800">{airport.orientation || "---"}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-road"></i>
                                    <span className="font-semibold text-gray-600">Surface:</span>
                                </div>
                                <span className="text-gray-800">
                                    {parseStringToArray(airport?.surface).join(', ')}

                                </span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-ruler"></i>
                                    <span className="font-semibold text-gray-600">Dimensions:</span>
                                </div>
                                <span className="text-gray-800">
                                    {airport.dimension_feets || "---"} / {airport.dimension_meters || "---"}
                                </span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-mountain"></i>
                                    <span className="font-semibold text-gray-600">Elevation:</span>
                                </div>
                                <span className="text-gray-800">
                                    {airport.elevation_feets || "---"} ft / {airport.elevation_meters || "---"} m
                                </span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-lightbulb"></i>
                                    <span className="font-semibold text-gray-600">Lighting:</span>
                                </div>
                                <span className="text-gray-800">{airport.lighting ? "Yes" : "No"}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-gas-pump"></i>
                                    <span className="font-semibold text-gray-600">Fuel:</span>
                                </div>
                                <span className="text-gray-800">
                                    {parseStringToArray(airport?.fuel).join(', ')}
                                </span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-parking"></i>
                                    <span className="font-semibold text-gray-600">Parking:</span>
                                </div>
                                <span className="text-gray-800">{airport.parking || "---"}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-broadcast-tower"></i>
                                    <span className="font-semibold text-gray-600">CTAF/UNICOM:</span>
                                </div>
                                <span className="text-gray-800">{airport.ctaf_unicom || "---"}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-map-signs"></i>
                                    <span className="font-semibold text-gray-600">Pattern:</span>
                                </div>
                                <span className="text-gray-800">{airport.pattern || "---"}</span>
                            </li>
                            <li className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <i className="text-gray-500 fas fa-clock"></i>
                                    <span className="font-semibold text-gray-600">Operation Hours:</span>
                                </div>
                                <span className="text-gray-800">{airport.operation_hours || "---"}</span>
                            </li>
                        </ul>
                    </div>

                    {airport?.ground_transportation &&
                        <div className="ground-transportation">
                            <p className="p-0 text-decoration-underline">
                                <strong>GROUND TRANSPORTATION</strong>
                            </p>
                            <p className="p-0 sub-title">{airport?.ground_transportation}</p>
                            <p className="p-0 sub-title">{airport?.additional_info}</p>
                        </div>
                    }
                </div>
            ))}
            {!showAll && airports.length > 1 && (
                <div className="flex justify-end more-airports">
                    <button className="bg-[#8EC639] text-white rounded-md py-2 px-4" onClick={() => setShowAll(true)}>
                        More Airports
                    </button>
                </div>
            )}
        </div>
    );
};
